import { OrderType } from './order-type.enum';

export class SearchRequest {
  [key: string]: any;
  sectionIds?: Array<number> = [];
  orderedSortFields?: string[] = [];
  updateTimeOrder?: OrderType;
  createTimeOrder?: OrderType;
  needPageNo?: boolean = false;
}
